import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNotebook: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconNotebook"><Path d="M7 2.5H3.5V21.5H7V2.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M9 21.5H20.5V2.5H9V21.5ZM12.5 7V9H17V7H12.5ZM12.5 11V13H17V11H12.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNotebook;
